module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-answer-first"><div class="answer-first"><div class="answer-title"><span class="title"> ' +
((__t = (title)) == null ? '' : __t) +
' </span></div><p class="body">一菲的“弹一闪”，美嘉的“盐汽水”还是熟悉的配方，还是原来的味道！“一菲”演唱的主题曲《最好的朋友在身边》是不是勾起了很多的美好回忆？那就拉上好友8月10日影院见吧</p><div class="btn"><a class="goWatch close" id="goWatch" href="javascript:void(0);">我知道了</a></div><div class="tryluck" style="display: none;">抽奖机会+1&nbsp;去试试手气</div></div></div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./modules/mask/answer.num.html
// module id = 32
// module chunks = 0